import React from "react";

/**
 * FitTrack COACH Logo — uses the high-resolution official brand image.
 * Transparent PNG stored at /brand/fittrackcoach-logo@2x.png
 *
 * The logo is a portrait lockup: F-icon tile on top + "FitTrack COACH" text below.
 *
 * Props:
 *   - height: rendered height in pixels (width auto-scales to preserve aspect)
 *   - className: extra classes for the wrapper
 */
export default function Logo({ height = 56, className = "" }) {
  return (
    <div className={`inline-flex items-center ${className}`} data-testid="brand-logo">
      <img
        src={`${process.env.PUBLIC_URL || ""}/brand/fittrackcoach-logo@2x.png?v=3`}
        srcSet={`${process.env.PUBLIC_URL || ""}/brand/fittrackcoach-logo@2x.png?v=3 1x, ${process.env.PUBLIC_URL || ""}/brand/fittrackcoach-logo.png?v=3 2x`}
        alt="FitTrack Coach"
        style={{ height: `${height}px`, width: "auto", display: "block" }}
        className="select-none"
        draggable="false"
      />
    </div>
  );
}
